export const DEFAULT_BANNED_WORDS = ['씨발', '시발', '개새끼', '병신', '좆', 'fuck', 'shit', 'bitch', 'asshole'];
/** 광고·현금 거래 문구(채팅 기본 차단). 게임 bannedWords와 합쳐 '*'로 가린다 */
export const DEFAULT_AD_WORDS = ['현질대행', '작업장', '현금거래', '계정판매', '계정팝니다', '계정삽니다', '골드판매', '골드팝니다', '골드삽니다', '아이템판매', '대리육성', '대리작업', '대리레벨업'];

// 금칙어를 같은 길이의 '*'로 가린다. 글자 사이에 공백·기호를 끼워 넣어도 잡는다.
export function maskBanned(value: string, extra: string[] = []): string {
  let result = value.normalize('NFKC');
  for (const word of [...DEFAULT_BANNED_WORDS, ...extra]) {
    const letters = [...word.normalize('NFKC').trim()];
    if (!letters.length) continue;
    const pattern = letters.map(letter => letter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('[\\p{P}\\p{S}\\s]*');
    result = result.replace(new RegExp(pattern, 'giu'), match => '*'.repeat([...match].length));
  }
  return result;
}

const LINK = /(?:https?:\/\/|www\.)[^\s]+|(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[a-z]{2,63})(?::\d+)?(?:\/[^\s]*)?/giu;
const EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/gu;
// 전화번호: 010-1234-5678 · 010 1234 5678 · 01012345678 · 02-123-4567 (공백·점·하이픈 끼움)
const PHONE = /(?<!\d)(?:\+?82[\s.-]*)?0\d{1,2}[\s.-]*\d{3,4}[\s.-]*\d{4}(?!\d)/gu;
// 메신저 아이디 안내: "카톡 abc123", "텔레 @abc", "디코: abc#1234", "오픈채팅 abc"
const MESSENGER = /(?:카카오톡|카톡|ㅋㅌ|kakao(?:talk)?|라인|line|텔레그램|텔레|telegram|tg|디스코드|디코|discord|오픈채팅|오픈톡|인스타|insta(?:gram)?|dm)\s*(?:아이디|id|아디)?\s*[:：]?\s*@?[A-Za-z0-9_.#-]{3,}/giu;

/** 연락처(이메일·전화·메신저 아이디)를 '[연락처]'로 바꾼다 — 사기·외부 거래 유도 차단 */
export function maskContacts(value: string): string {
  return value.replace(EMAIL, '[연락처]').replace(MESSENGER, '[연락처]').replace(PHONE, '[연락처]');
}

// 채팅용: 금칙어·광고 문구를 가리고, 이메일 → URL·도메인('[링크]') → 메신저 아이디·전화('[연락처]') 순서로 바꾼다.
// (도메인을 먼저 바꿔야 'open.kakao.com/…'이 메신저 아이디로 반쯤 잘리지 않는다)
export function filterChat(value: string, extra: string[] = []): string {
  return maskBanned(value, [...DEFAULT_AD_WORDS, ...extra]).replace(EMAIL, '[연락처]').replace(LINK, '[링크]').replace(MESSENGER, '[연락처]').replace(PHONE, '[연락처]');
}

export function neutralizeMentions(value: string): string {
  return value.replace(/@/g, '@\u200b').replace(/<([@#])/g, '<\u200b$1');
}

// 운영자 사칭 방지 예약 닉네임. 한글은 포함 여부, 영문은 글자 덩어리(숫자·밑줄·한글로 나뉜 조각)가 같은지로 본다 —
// 'Pigment'·'devil'·'Staffan' 같은 평범한 이름을 막지 않으려고 짧은 영문 단어는 통째로 같을 때만 막고, 긴 단어(admin 등)만 앞뒤 붙은 형태도 막는다.
export const DEFAULT_RESERVED_KO = ['운영자', '운영진', '운영팀', '운영', '관리자', '관리팀', '개발자', '개발진', '개발팀', '공식', '시스템', '지엠'];
export const DEFAULT_RESERVED_EN_EXACT = ['gm', 'dev', 'mod', 'ops', 'cs', 'sys', 'admin', 'administrator', 'system', 'staff', 'support', 'official', 'moderator', 'operator', 'developer', 'gamemaster', 'owner'];
export const DEFAULT_RESERVED_EN_AFFIX = ['admin', 'moderator', 'gamemaster', 'operator'];

/** 사칭이 의심되는 예약 닉네임인지. extra는 게임이 더하는 부분 문자열(소문자 비교) */
export function isReservedName(name: string, extra: string[] = []): boolean {
  const lower = name.normalize('NFKC').toLowerCase();
  if (DEFAULT_RESERVED_KO.some(word => lower.includes(word))) return true;
  if (extra.some(word => word && lower.includes(word.normalize('NFKC').toLowerCase()))) return true;
  for (const token of lower.match(/[a-z]+/g) ?? []) {
    if (DEFAULT_RESERVED_EN_EXACT.includes(token)) return true;
    if (DEFAULT_RESERVED_EN_AFFIX.some(word => token.startsWith(word) || token.endsWith(word))) return true;
  }
  return false;
}
